import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { GenerateLinksRequestDto, GenerateLinksResponseDto, MediaTypeEnum, ProductDto, ProductPackageDto, ResponseDto, UserDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpPackageService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/package');
	}

	getPackages(productId: number): Observable<ProductPackageDto[]> {
        return super.get(`/${productId}/packages`);
    }
    getPackagesMinimal(productId: number): Observable<ProductPackageDto[]> {
        return super.get(`/${productId}/packages-minimal`);
    }
    savePackage(input: ProductPackageDto): Observable<ResponseDto> {
        return super.post(`/save`, input);
    }
	generateLinksForPackages(input: GenerateLinksRequestDto): Observable<GenerateLinksResponseDto> {
        return super.post(`/generate-links`, input);
    }
}
